/** @format */

import { Container } from "../../components/layouts/Container";
import EmochiEconomicSelectElement from "../../components/ui_elements/emochi/EconomicSelect/EconomicSelectElement";
import styled from "styled-components";
import { mixins } from "../../css/variables/mixins";

const Content = styled.div`
  max-width: 750px;
  margin: 0 auto;
  padding: 0 24px;

  ${mixins.screenUnder()} {
    padding: 0 16px;
  }
`;

const TitleStyle = styled.h1`
  ${mixins.screenUnder()} {
    text-align: left;
  }
`;

const EmochiEconomicSelect = ({ redirect }: { redirect?: boolean }) => {
  return (
    <Container isLogin={true} background={"default"} align={"top"} redirect={redirect}>
      <Content>
        <TitleStyle>ご利用サービスの内容</TitleStyle>
        <EmochiEconomicSelectElement redirect={redirect} />
      </Content>
    </Container>
  );
};

export default EmochiEconomicSelect;
